export default __webpack_public_path__ + "static/media/6.92db3597.png";